import React from "react";
import { User } from "lucide-react";

export function UserAvatarCard({
  icon: Icon = User,
  iconClassName = "",
  iconSize = "md",
}) {
  const sizeClasses = {
    sm: "w-12 h-12 p-3",
    md: "w-16 h-16 p-4",
    lg: "w-20 h-20 p-5",
  };

  const iconSizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  return (
    <div
      className={`
        ${sizeClasses[iconSize]}
        bg-white 
        rounded-2xl 
        shadow-sm 
        flex 
        items-center 
        justify-center
        ${iconClassName}
      `}
    >
      <Icon
        fill="#A4A8C3"
        strokeWidth={0}
        className={`${iconSizes[iconSize]}`}
      />
    </div>
  );
}
